<template>
  <VaPopover trigger="hover">
    <div class="flex flex-row items-center shrink truncate">
      <VaAvatar class="mr-2" :fallback-text="accountDisplayName(accountStore.currentAccount).substring(0,1)" />
      <span class="truncate">
        {{ accountDisplayName(accountStore.currentAccount) }}
      </span>
    </div>

    <template #body>
      <p class="px-4 pt-3 pb-1 text-sm text-neutral-300 text-center">{{ t('accounts.switchAccount') }}</p>
      <VaMenuList>
        <VaMenuItem v-for="account in accountStore.accounts" :key="account.id" class="w-full pointer" @click="accountStore.switchAccount(account.id)">
          {{ accountDisplayName(account) }}
        </VaMenuItem>
      </VaMenuList>

      <div class="p-4 text-center">
        <VaButton :to="{ name: 'account.create' }">
          {{ t('accounts.createTitle') }}
        </VaButton>
      </div>
    </template>
  </VaPopover>
</template>

<script lang="ts" setup>
import { VaAvatar, VaButton, VaMenuItem, VaMenuList, VaPopover } from 'vuestic-ui'
import { useAccountStore } from '@/stores/AccountStore'
import { accountDisplayName } from '@/models/Account'
import { useI18n } from 'vue-i18n'

const accountStore = useAccountStore()
const { t } = useI18n()
</script>
